/* eslint-disable @typescript-eslint/prefer-optional-chain */
/* eslint-disable @typescript-eslint/no-empty-interface */
import React, { useMemo, useState, useContext, useEffect } from 'react';
import classnames from 'classnames';
import { useRequest } from 'ahooks';
import { Card } from 'tea-component';
import { context as Context } from '@gp/components/Context';
import Loading from '@gp/components/Loading';
import NoData from '@gp/components/NoData';
import DataTime from '@gp/components/DataTime';
import ShowAllToggleBtn from '@gp/components/ShowAllToggleBtn';
import Employees from '@gp/pages/Pipeline/ProjectDetails/Stakeholder/components/StakeholderDetails/components/Employees';
import { queryManagementTeamDataOfPeople } from '@gp/pages/StudioDashboard/StudioOverall/services/studioOverallDetail';
// import { formatDateStr, replaceTemplateStr } from '@gp/utils/common';
import { formatDateStr } from '@gp/utils/common';
// import { MANAGEMENT_TEAM_MIN_SHOW_CELLS, MANAGEMENT_TEAM_DESCRIPTION_TEMPLATE } from '../../utils/constants';
import { MANAGEMENT_TEAM_MIN_SHOW_CELLS } from '../../utils/constants';

import type { IBaseProps } from '@home/types/common';

import './index.scss';

interface IManagementTeamProps extends IBaseProps {}

const ManagementTeam: React.FC<IManagementTeamProps> = (props) => {
  const { style, className, ...remains } = props;

  // const { studioId, studioName } = useContext<StudioOverallDetailContextTypes>(Context);
  const { studioId } = useContext<StudioOverallDetailContextTypes>(Context);

  const {
    loading: isEmployeesDataLoading,
    data: employeesData,
    run: runQueryManagementTeamDataOfPeople,
  } = useRequest(queryManagementTeamDataOfPeople, { manual: true });

  const employeesUpdateTimeFormatted = formatDateStr(employeesData?.update_time);

  const employees = useMemo(() => {
    const employeesTemp = employeesData?.list;
    return Array.isArray(employeesTemp) ? employeesTemp : [];
  }, [employeesData]);
  const isHasData = !isEmployeesDataLoading && employees && employees?.length > 0;
  const isNoData = !isEmployeesDataLoading && (!employees || !employees?.length);

  // const [description, setDescription] = useState('');

  const [isShowAll, setIsShowAll] = useState(false);

  const showEmployeesCount = useMemo(() => {
    if (!Array.isArray(employees)) return 0;
    if (isShowAll) return employees?.length;
    return Math.min(employees?.length, MANAGEMENT_TEAM_MIN_SHOW_CELLS);
  }, [isShowAll, employees]);

  // useEffect(() => {
  //   const source = {
  //     studioName: studioName || '',
  //     ceoName: employees?.[0]?.name || '',
  //   };
  //   const description = replaceTemplateStr(MANAGEMENT_TEAM_DESCRIPTION_TEMPLATE, source);
  //   setDescription(description);
  // }, [studioName, employees]);

  useEffect(() => {
    runQueryManagementTeamDataOfPeople({ studio_id: studioId });
  }, [studioId]);

  return (
    <>
      <Card
        {...remains}
        style={style}
        className={classnames('dbg-studio-people-management-team-card dbg-trigger-view-card', className)}
      >
        <Card.Body
          title={
            <div style={{ display: 'flex', alignItems: 'center' }}>
              Management Team
              {!!employeesUpdateTimeFormatted && (
                <DataTime style={{ marginLeft: 6 }} dateType="Month" date={employeesUpdateTimeFormatted} />
              )}
            </div>
          }
          className="dbg-studio-people-management-team-card-content"
        >
          {/* 加载动画 */}
          {isEmployeesDataLoading && <Loading loading style={{ height: 350 }} />}
          {/* 无数据 */}
          {isNoData && <NoData height={200} constomStyle={{ fontSize: 14 }} />}
          {/* Management Team */}
          {isHasData && (
            <>
              {/* <section className="dbg-studio-people-management-team-description font14">{description}</section> */}
              {employees && employees.length > 0 && (
                <div className="dbg-studio-people-management-team-employee-list-container">
                  <Employees organization="" employees={employees} showCount={showEmployeesCount} />
                </div>
              )}
              {employees && employees?.length > MANAGEMENT_TEAM_MIN_SHOW_CELLS && (
                <ShowAllToggleBtn style={{ marginTop: 10 }} isShowAll={isShowAll} setIsShowAll={setIsShowAll} />
              )}
            </>
          )}
        </Card.Body>
      </Card>
    </>
  );
};

export default React.memo(ManagementTeam);
